exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-outline-grey[data-v-0026a51f]{color:#aaa;border-color:#aaa}.btn-outline-grey:not(:disabled):not(.disabled).active[data-v-0026a51f],.btn-outline-grey[data-v-0026a51f]:not(:disabled):not(.disabled):active,.show>.btn-outline-grey[data-v-0026a51f]{color:#fff;background-color:#aaa;border-color:#aaa}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0026a51f","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/qrcode/qr-invite-button.vue
// module id = 1774
// module chunks = 0